import { render } from "./corporateManage.vue?vue&type=template&id=19fe5ffe"
import script from "./corporateManage.vue?vue&type=script&lang=js"
export * from "./corporateManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__